/**
 * api - 傳輸層
 * 授權 - 權杖
 * @author J
 * @since 2024-04-30 07:34:25
 */

import http from "@/v2/api"

/**
 * 基礎 - 路徑
 */
const baseUri = "/api/session"

/**
 * 銷毀
 */
export const updateAuthorizationSessionDestroy = () => {
    return http.delete(
        `${baseUri}/destroy`,
        {},
        {
            opts: {
                default: {
                    failure: false
                }
            }
        }
    )
}
